import { memo } from 'react';
import { Tooltip } from '@mui/material';
import styles from './ChartHeader.module.css';
import { useChartGridContext } from '../../contexts/ChartGridContext';

const ChartHeader = memo(({ question, surveyQuestionId, chartType, peersOnly, retakeQuestionRef, peersRef, answered }) => {

    const toolbarStyle = { padding: "0 0 0.25rem 0.5rem", alignItems: "center", gap: "1rem" };
    const buttonGroupStyle = { display: "flex", alignItems: "center", gap: "2px" };

    const { showModalSurveyQuestion, togglePeersOnly } = useChartGridContext();

    const updateResponse = () => {
        showModalSurveyQuestion(surveyQuestionId);
    }
    const updatePeersOnly = () => {
        togglePeersOnly(surveyQuestionId);
    }

    // console.log(`question: ${question}, chartType: ${chartType}, peersOnly: ${peersOnly}, answered: ${answered}`);

    return (
        <div className="toolbar" style={toolbarStyle}>
            <h3>{question}</h3>
            <div style={buttonGroupStyle}>
                {
                    ((chartType !== "gauge") && (chartType !== "nested pie chart")) &&
                    <Tooltip title={`Click to include ${peersOnly ? "all responses" : "only responses from peers"}`} arrow>
                        <button className={`${styles.peersOnly} ${peersOnly ? styles.selected : ""}`} onClick={updatePeersOnly} ref={peersRef}></button>
                    </Tooltip>
                }
                <Tooltip title={answered ? "Click to update your response" : "Click to answer this question"} arrow>
                    <button className={answered ? styles.update : styles.answer} onClick={updateResponse} ref={retakeQuestionRef}></button>
                </Tooltip>
            </div>
        </div>
    )
});

export default ChartHeader;
